import { render, staticRenderFns } from "./AddEditTemplate.vue?vue&type=template&id=0d54fb88&"
import script from "./AddEditTemplate.vue?vue&type=script&lang=js&"
export * from "./AddEditTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AddEditTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports